/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingnoplacesdescription3Inputs */

const en_crosspostingnoplacesdescription3 = /** @type {(inputs: Crosspostingnoplacesdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a place first, then connect its social accounts to start crossposting.`)
};

const de_crosspostingnoplacesdescription3 = /** @type {(inputs: Crosspostingnoplacesdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstelle zuerst einen Ort und verbinde dann seine Social-Media-Konten, um gleichzeitig zu posten.`)
};

/**
* | output |
* | --- |
* | "Create a place first, then connect its social accounts to start crossposting." |
*
* @param {Crosspostingnoplacesdescription3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingnoplacesdescription3 = /** @type {((inputs?: Crosspostingnoplacesdescription3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingnoplacesdescription3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingnoplacesdescription3(inputs)
	return de_crosspostingnoplacesdescription3(inputs)
});
export { crosspostingnoplacesdescription3 as "crosspostingNoPlacesDescription" }